import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type ThemeMode = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private themeKey = 'preferred-theme';
  private isDarkModeSubject = new BehaviorSubject<boolean>(this.getInitialThemeState());
  
  isDarkMode$: Observable<boolean> = this.isDarkModeSubject.asObservable();

  constructor() {
    // Apply theme on service initialization
    this.applyTheme(this.isDarkModeSubject.value);
  }

  toggleTheme(): void {
    const newThemeValue = !this.isDarkModeSubject.value;
    this.isDarkModeSubject.next(newThemeValue);
    this.saveThemePreference(newThemeValue);
    this.applyTheme(newThemeValue);
  }

  private getInitialThemeState(): boolean {
    // Check local storage first
    const savedTheme = localStorage.getItem(this.themeKey);
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    
    // If no saved preference, check system preference
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  private saveThemePreference(isDark: boolean): void {
    localStorage.setItem(this.themeKey, isDark ? 'dark' : 'light');
  }

  private applyTheme(isDark: boolean): void {
    document.body.classList.toggle('dark-theme', isDark);
  }
} 